import { useEffect, useState } from 'react'
import { ArrayParam, NumberParam, useQueryParam } from 'use-query-params'
import { Icon } from '@iconify/react'
import isEmpty from 'lodash.isempty'
import { Button, Dropdown, Checkbox } from '@pepper/ui'

import { statusOptions, StatusOption } from '../schema'
import s from './StatusFilter.module.css'

export const StatusFilter = () => {
  const [open, setOpen] = useState(false)
  const [statusFilters, setStatusFilters] = useQueryParam('stage', ArrayParam)
  const [_, setCurrentPage] = useQueryParam('currentPage', NumberParam)
  const [selectedValues, setSelectedValues] = useState<(string | null)[]>([])

  const isChecked = (checkValue: StatusOption) => {
    return selectedValues.includes(checkValue.id)
  }

  const handleChange = (option: StatusOption) => {
    if (isChecked(option)) {
      setSelectedValues(selectedValues.filter(id => id !== option?.id))
    } else {
      setSelectedValues([...selectedValues, option.id])
    }
  }

  const handleApply = () => {
    setStatusFilters(selectedValues)
    setCurrentPage(0)
    setOpen(false)
  }

  const handleClose = () => {
    setSelectedValues([])
    setStatusFilters(undefined)
    setCurrentPage(0)
    setOpen(false)
  }

  const onVisibleChange = (visible: boolean) => {
    if (isEmpty(statusFilters)) setSelectedValues([])
    setOpen(visible)
  }

  const normalizedStatusOptions: Record<string, StatusOption> =
    statusOptions?.reduce(
      (prev, curr) => ({
        ...prev,
        [curr.id]: curr,
      }),
      {}
    )

  const appliedFilterText = (): string => {
    if (statusFilters?.length === 0 || !statusFilters) {
      return ''
    } else if (statusFilters?.length === 1 && statusFilters[0] !== null) {
      return normalizedStatusOptions[statusFilters?.[0]].label
    } else {
      return `${statusFilters?.length} selected`
    }
  }

  useEffect(() => {
    setSelectedValues(statusFilters ?? [])
  }, [statusFilters])

  const menu = () => {
    return (
      <div className={s.wrapper}>
        <div className={s.title}>Project statuses</div>
        <div className={s.options}>
          {statusOptions.map(option => {
            const StatusIcon = option?.icon
            return (
              <Checkbox
                key={option.id}
                className={s.option}
                onChange={() => handleChange(option)}
                checked={isChecked(option)}
              >
                <div className={s.label}>
                  {option.label} {StatusIcon && <StatusIcon />}
                </div>
              </Checkbox>
            )
          })}
        </div>
        <div className={s.divider} />
        <div className={s.actions}>
          <Button className={s.actionBtn} type="primary" onClick={handleApply}>
            Apply
          </Button>
          <Button className={s.actionBtn} type="ghost" onClick={handleClose}>
            Reset
          </Button>
        </div>
      </div>
    )
  }

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      visible={open}
      onVisibleChange={onVisibleChange}
    >
      <Button size="small" className={s.button}>
        Status
        <div className={s.selected}>{appliedFilterText()}</div>
        <Icon
          icon="material-symbols:keyboard-arrow-down-rounded"
          width={16}
          height={16}
        />
      </Button>
    </Dropdown>
  )
}
